module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 0
// module chunks = business-manager/mini-home business-manager/shoutout-popup business-manager/video-library-page shoutout/shoutout full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard app-settings/app-settings